import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { getUrl, Resource } from '@ngxp/rest';
import { isNil } from 'lodash-es';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { loadUserAction, logInUserAction, logOutUserAction, unauthorizeUserAction } from './user.actions';
import { UserResource } from './user.model';
import { userByUriSelector, userSelector } from './user.selectors';
import { UserRootState } from './user.state';

@Injectable({ providedIn: 'root' })
export class UserFacade {
	constructor(private store: Store<UserRootState>) {}

	logIn() {
		this.store.dispatch(logInUserAction());
	}

	logOut() {
		this.store.dispatch(logOutUserAction());
	}

	unauthorize() {
		this.store.dispatch(unauthorizeUserAction());
	}

	getUserByUri(resource: Resource, linkRel: string): Observable<UserResource> {
		return this.store.select(userByUriSelector(getUrl(resource, linkRel))).pipe(
			tap(user => {
				if (isNil(user)) {
					this.store.dispatch(loadUserAction({ resource, linkRel }));
				}
			})
		);
	}

	getCurrentUser(): Observable<UserResource> {
		return this.store.select(userSelector);
	}
}
